/* Jegit – schlanke Erweiterungen für Dawn (kein Framework, kein jQuery) */
(function () {
  'use strict';

  /* ---------- Lieferzeit-Schätzung ---------- */
  const TZ = 'Europe/Berlin';
  function berlinParts(d) {
    const f = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short' });
    const o = {};
    f.formatToParts(d).forEach((p) => (o[p.type] = p.value));
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, min: +o.minute };
  }
  const pad = (n) => String(n).padStart(2, '0');
  function isWorkday(date, holidays) {
    const dow = date.getUTCDay();
    if (dow === 0 || dow === 6) return false;
    const md = pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
    const ymd = date.getUTCFullYear() + '-' + md;
    return !(holidays.has(md) || holidays.has(ymd));
  }
  function addWorkdays(date, n, holidays) {
    const d = new Date(date);
    let added = 0;
    while (added < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (isWorkday(d, holidays)) added++;
    }
    return d;
  }
  function nextWorkday(date, holidays) {
    const d = new Date(date);
    do d.setUTCDate(d.getUTCDate() + 1); while (!isWorkday(d, holidays));
    return d;
  }
  function renderDelivery(el) {
    const min = +el.dataset.min || 0, max = +el.dataset.max || min, cutoff = +el.dataset.cutoff || 14;
    const holidays = new Set((el.dataset.holidays || '').split(',').map((s) => s.trim()).filter(Boolean));
    const locale = el.dataset.locale || document.documentElement.lang || 'de-DE';
    const now = berlinParts(new Date());
    const today = new Date(Date.UTC(now.y, now.m - 1, now.d, 12));
    const beforeCutoff = now.h < cutoff;
    const dispatch = isWorkday(today, holidays) && beforeCutoff ? today : nextWorkday(today, holidays);
    const earliest = addWorkdays(dispatch, min, holidays);
    const latest = addWorkdays(dispatch, max, holidays);
    const fmt = (d) => d.toLocaleDateString(locale, { weekday: 'short', day: '2-digit', month: '2-digit', timeZone: 'UTC' });
    // Countdown bis zum nächsten Bestellschluss
    const minutesNow = now.h * 60 + now.min;
    const daysUntilDispatch = Math.round((dispatch - today) / 86400000);
    let left = daysUntilDispatch * 1440 + cutoff * 60 - minutesNow;
    if (left < 0) left = 0;
    const h = Math.floor(left / 60), m = left % 60;
    const countdown = h + ' ' + (el.dataset.h || 'Std.') + ' ' + m + ' ' + (el.dataset.m || 'Min.');
    el.querySelectorAll('[data-jg-earliest]').forEach((n) => (n.textContent = fmt(earliest)));
    el.querySelectorAll('[data-jg-latest]').forEach((n) => (n.textContent = fmt(latest)));
    el.querySelectorAll('[data-jg-countdown]').forEach((n) => (n.textContent = countdown));
    el.classList.add('is-ready');
  }
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-jg-delivery]').forEach((el) => {
      renderDelivery(el);
      if (!el._jgTimer) el._jgTimer = setInterval(() => renderDelivery(el), 30000);
    });
  }

  /* ---------- Sticky Add-to-Cart ---------- */
  if (!customElements.get('jg-sticky-atc')) {
    customElements.define('jg-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        const section = this.dataset.section;
        if (this.parentElement !== document.body) {
          // aus dem Info-Container lösen (position: fixed) und Duplikate entfernen
          document.querySelectorAll('body > jg-sticky-atc[data-section="' + section + '"]').forEach((n) => n.remove());
          document.body.appendChild(this);
          return;
        }
        if (this._init) return;
        this._init = true;
        this.mainBtn = document.getElementById('ProductSubmitButton-' + section);
        if (!this.mainBtn) return;
        this.form = this.mainBtn.closest('product-form') || this.mainBtn;
        this.hidden = false;
        // Platz unter dem Footer freihalten, damit die Leiste ihn nicht verdeckt
        const setH = () => document.documentElement.style.setProperty('--jg-sticky-h', this.offsetHeight + 'px');
        setH();
        window.addEventListener('resize', setH, { passive: true });
        // Sichtbar, sobald gescrollt wurde und der Haupt-Button nicht im Viewport ist
        // (auch wenn er noch unterhalb liegt – auf Mobil liegt er oft unter dem Falz)
        let ticking = false;
        const update = () => {
          ticking = false;
          const r = this.mainBtn.getBoundingClientRect();
          const inView = r.bottom > 0 && r.top < window.innerHeight;
          this.classList.toggle('is-visible', !inView && window.scrollY > 250);
        };
        const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
        this.querySelector('button').addEventListener('click', () => {
          if (this.dataset.mode === 'add' && !this.mainBtn.disabled) this.mainBtn.click();
          else this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.sync(section), 50));
        }
      }
      sync(section) {
        const price = document.querySelector('#price-' + section + ' .price__sale:not([hidden]) .price-item--sale, #price-' + section + ' .price-item--regular');
        const target = this.querySelector('.jg-sticky-atc__now') || this.querySelector('.jg-sticky-atc__price');
        if (price && target) target.textContent = price.textContent.trim();
        const btn = this.querySelector('button');
        btn.disabled = this.mainBtn.disabled;
      }
    });
  }

  /* ---------- Laborbeleg: Laborberichte-Akkordeon öffnen; Angebots-Banner: Haupt-Warenkorb-Button auslösen ---------- */
  document.addEventListener('click', (e) => {
    // "Was bedeutet das?" – Erklärung auf- und zuklappen
    const tipBtn = e.target.closest('[data-jg-tip]');
    if (tipBtn) {
      const tip = document.getElementById(tipBtn.getAttribute('aria-controls'));
      const open = tipBtn.getAttribute('aria-expanded') !== 'true';
      tipBtn.setAttribute('aria-expanded', String(open));
      if (tip) tip.hidden = !open;
      return;
    }
    const lab = e.target.closest('[data-jg-open-lab]');
    if (lab) {
      const details = [...document.querySelectorAll('.product__accordion details')].find((d) => d.querySelector('.jg-analyses'));
      if (details) {
        e.preventDefault();
        details.open = true;
        details.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    const proxy = e.target.closest('[data-jg-atc-proxy]');
    if (proxy) {
      if (proxy.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      const main = document.querySelector('button[id^="ProductSubmitButton-"]');
      if (main && !main.disabled) {
        e.preventDefault();
        main.click();
      }
    }
  });

  /* ---------- Vorher/Nachher ---------- */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-jg-compare]').forEach((el) => {
      const input = el.querySelector('input[type=range]');
      if (!input || input._jg) return;
      input._jg = true;
      const set = () => el.style.setProperty('--jg-pos', input.value + '%');
      input.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Schritte (Flow) ---------- */
  function initSteps(root) {
    (root || document).querySelectorAll('[data-jg-steps]').forEach((el) => {
      if (el._jg) return;
      el._jg = true;
      const tabs = el.querySelectorAll('[data-step-tab]');
      const panes = el.querySelectorAll('[data-step-media]');
      const activate = (i) => {
        tabs.forEach((t, j) => { t.classList.toggle('is-active', i === j); t.setAttribute('aria-selected', i === j); });
        panes.forEach((p, j) => p.classList.toggle('is-active', i === j));
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => activate(i));
        if (el.dataset.motion === 'hover') t.addEventListener('mouseenter', () => activate(i));
      });
    });
  }

  /* ---------- Karte: 2-Klick-Lösung (DSGVO) ---------- */
  function initMaps(root) {
    (root || document).querySelectorAll('[data-jg-map]').forEach((el) => {
      const btn = el.querySelector('[data-jg-map-load]');
      if (!btn || btn._jg) return;
      btn._jg = true;
      btn.addEventListener('click', () => {
        const f = document.createElement('iframe');
        f.src = el.dataset.src;
        f.loading = 'lazy';
        f.referrerPolicy = 'no-referrer-when-downgrade';
        f.title = el.dataset.title || 'Map';
        el.querySelector('.jg-map__frame').replaceChildren(f);
      });
    });
  }

  /* ---------- Laufband: nur so viele Kopien wie für eine lückenlose Schleife nötig ---------- */
  function fillMarquee(track) {
    const groups = track.querySelectorAll('.jg-marquee__group');
    const first = groups[0];
    if (!first) return;
    const w = first.getBoundingClientRect().width;
    if (!w) return;
    // eine Kopie wird weggescrollt, der Rest muss den Viewport füllen
    const needed = Math.max(2, Math.ceil(window.innerWidth / w) + 1);
    for (let i = groups.length; i < needed; i++) {
      const c = first.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      track.appendChild(c);
    }
    const n = track.querySelectorAll('.jg-marquee__group').length;
    track.style.setProperty('--jg-marquee-shift', (-100 / n) + '%');
  }
  function initMarquees(root) {
    (root || document).querySelectorAll('[data-jg-marquee]').forEach(fillMarquee);
  }
  let jgMarqueeResize;
  window.addEventListener('resize', () => { clearTimeout(jgMarqueeResize); jgMarqueeResize = setTimeout(() => initMarquees(), 200); });

  /* ---------- Warenkorb neu rendern (Drawer oder Warenkorbseite) ---------- */
  function jgCartSections(inDrawer) {
    if (inDrawer) return ['cart-drawer', 'cart-icon-bubble'];
    return [...document.querySelectorAll('#main-cart-items[data-id], #main-cart-footer[data-id]')].map((el) => el.dataset.id).concat('cart-icon-bubble');
  }
  function jgRenderCart(state, inDrawer) {
    const drawer = document.querySelector('cart-drawer');
    if (inDrawer && drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(state); return; }
    const sections = state.sections || {};
    Object.keys(sections).forEach((id) => {
      const target = document.getElementById('shopify-section-' + id);
      const html = sections[id] && new DOMParser().parseFromString(sections[id], 'text/html').querySelector('.shopify-section');
      if (target && html) target.innerHTML = html.innerHTML;
    });
  }

  /* ---------- Gratis-Geschenk in den Warenkorb legen ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-jg-gift-add]');
    if (!btn) return;
    const inDrawer = !!btn.closest('cart-drawer');
    btn.disabled = true;
    btn.classList.add('loading');
    try {
      const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.jgGiftAdd), quantity: 1 }], sections: jgCartSections(inDrawer) }),
      });
      if (!res.ok) throw new Error(res.status);
      jgRenderCart(await res.json(), inDrawer);
    } catch (err) {
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  });

  // Geschenk-Auswahl als Overlay: Zeile im Warenkorb öffnet es, Schritt 2 = Sorten (z. B. Oliven).
  // Anderes Geschenk wählen = tauschen; die Geschenk-Zeile kann gekaufte Einheiten desselben Produkts enthalten -> nur 1 Stück abziehen.
  const jgGiftSheet = (box, open, step) => {
    const sheet = box && box.querySelector('[data-jg-gift-sheet]');
    if (!sheet) return;
    sheet.hidden = !open;
    box.classList.toggle('is-open', open);
    sheet.querySelectorAll('[data-jg-gift-step]').forEach((s) => { s.hidden = s.dataset.jgGiftStep !== String(step || 1); });
    if (open) {
      const cur = sheet.querySelector('[data-jg-gift-step]:not([hidden])');
      const focus = cur && (cur.querySelector('.jg-gift__row.is-active') || cur.querySelector('.jg-gift__row'));
      if (focus) focus.focus({ preventScroll: true });
    }
  };
  document.addEventListener('click', async (e) => {
    const box = e.target.closest('[data-jg-gift]');
    if (!box) return;
    if (e.target.closest('[data-jg-gift-open]')) return jgGiftSheet(box, true, 1);
    if (e.target.closest('[data-jg-gift-close]')) return jgGiftSheet(box, false);
    if (e.target.closest('[data-jg-gift-back]')) return jgGiftSheet(box, true, 1);
    if (e.target.closest('[data-jg-gift-group]')) return jgGiftSheet(box, true, 2);
    const pick = e.target.closest('[data-jg-gift-pick]');
    if (!pick) return;
    jgGiftSheet(box, false);
    if (pick.classList.contains('is-active')) return; // bereits gewählt
    const inDrawer = !!pick.closest('cart-drawer');
    const key = box.dataset.key;
    const post = (path, body) => fetch(((window.routes && window.routes[path + '_url']) || '/' + path.replace('_', '/')) + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
    }).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); });
    box.setAttribute('aria-busy', 'true');
    const variantId = Number(pick.dataset.jgGiftPick);
    const { title, err: errText } = box.dataset;
    try {
      if (key) await post('cart_change', { id: key, quantity: Math.max(0, Number(box.dataset.qty || 1) - 1) });
      let state = await post('cart_add', { items: [{ id: variantId, quantity: 1 }], sections: jgCartSections(inDrawer) });
      // Sicherheitsnetz: Hat Shopify das Geschenk nicht rabattiert (nicht kombinierbarer Rabatt im Warenkorb),
      // das Stück wieder herausnehmen, damit niemand versehentlich dafür zahlt.
      let blocked = false;
      const cart = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const lines = cart.items.filter((i) => i.variant_id === variantId);
      const free = lines.some((i) => (i.line_level_discount_allocations || []).some((a) => a.amount > 0 && a.discount_application && a.discount_application.title === title));
      if (lines.length && !free) {
        blocked = true;
        const l = lines[lines.length - 1];
        state = await post('cart_change', { id: l.key, quantity: l.quantity - 1, sections: jgCartSections(inDrawer) });
      }
      jgRenderCart(state, inDrawer);
      if (blocked && errText) {
        const scope = inDrawer ? document.querySelector('cart-drawer') : document;
        const nb = scope && scope.querySelector('[data-jg-gift]');
        if (nb) nb.insertAdjacentHTML('beforeend', '<p class="jg-gift__err" role="alert"></p>');
        if (nb) nb.lastElementChild.textContent = errText;
      }
    } catch (err) {
      box.removeAttribute('aria-busy');
    }
  });
  // Escape schließt nur das Overlay, nicht den ganzen Warenkorb
  document.addEventListener('keyup', (e) => {
    if (e.key !== 'Escape') return;
    const box = document.querySelector('[data-jg-gift].is-open');
    if (box) { jgGiftSheet(box, false); e.stopPropagation(); }
  }, true);

  /* ---------- Gutscheincodes im Warenkorb (Drawer + Warenkorbseite) ---------- */
  if (!customElements.get('jg-cart-discount')) {
    customElements.define('jg-cart-discount', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-jg-discount-form]');
        this.error = this.querySelector('.jg-discount__error');
        this.list = this.querySelector('[data-jg-list]');
        this.currentCodes = [...this.querySelectorAll('[data-jg-remove]')].map((b) => b.dataset.jgRemove).filter(Boolean);
        if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
        this.addEventListener('click', (e) => {
          const b = e.target.closest('[data-jg-remove]');
          if (b && b.dataset.jgRemove) this.remove(b.dataset.jgRemove);
        });
        // Aufklappen: Eingabefeld sichtbar machen (im Drawer sonst unter der fixierten Kasse-Leiste) und fokussieren
        const add = this.querySelector('.jg-discount__add');
        if (add) add.addEventListener('toggle', () => {
          if (!add.open || !this.form) return;
          requestAnimationFrame(() => {
            this.form.querySelector('input')?.focus({ preventScroll: true });
            const scroller = this.closest('.drawer__inner');
            if (!scroller) return this.form.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            const cta = scroller.querySelector('.jg-drawer-cta');
            const limit = cta && getComputedStyle(cta).position === 'sticky' ? cta.getBoundingClientRect().top : scroller.getBoundingClientRect().bottom;
            const over = this.form.getBoundingClientRect().bottom + 12 - limit;
            if (over > 0) scroller.scrollBy({ top: over, behavior: 'smooth' });
          });
        });
        this.load();
      }
      // vollständige Code-Liste (inkl. ungültiger) aus /cart.js – Liquid liefert nur angewandte Rabatte
      async load() {
        try {
          const cart = await (await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })).json();
          this.renderCodes(cart.discount_codes || []);
        } catch (e) { /* Server-Darstellung bleibt */ }
      }
      renderCodes(list) {
        this.currentCodes = list.map((d) => d.code);
        if (!this.list) return;
        const amounts = {};
        this.list.querySelectorAll('.jg-discount__chip').forEach((li) => {
          const code = li.querySelector('.jg-discount__code')?.textContent.trim().toLowerCase();
          if (code) amounts[code] = li.querySelector('.jg-discount__amount')?.textContent || '';
        });
        const tpl = this.querySelector('[data-jg-chip-template]');
        const msg = this.querySelector('.jg-discount__message');
        const invalid = [];
        this.list.replaceChildren(...list.map((d) => {
          const li = tpl.content.firstElementChild.cloneNode(true);
          li.querySelector('.jg-discount__code').textContent = d.code;
          li.querySelector('.jg-discount__amount').textContent = d.applicable ? amounts[d.code.toLowerCase()] || '' : '';
          const btn = li.querySelector('[data-jg-remove]');
          btn.dataset.jgRemove = d.code;
          btn.setAttribute('aria-label', (btn.dataset.label || '').replace('__CODE__', d.code));
          if (!d.applicable) { li.classList.add('is-invalid'); invalid.push(d.code); }
          return li;
        }));
        if (msg) {
          msg.hidden = !invalid.length;
          msg.textContent = invalid.map((c) => (msg.dataset.msg || '').replace('__CODE__', c)).join(' ');
        }
      }
      codes() { return (this.currentCodes || []).slice(); }
      add() {
        const input = this.form.querySelector('input[name="code"]');
        const code = (input.value || '').trim();
        if (!code) { input.focus(); return; }
        const codes = this.codes().filter((c) => c.toLowerCase() !== code.toLowerCase());
        codes.push(code);
        this.update(codes);
      }
      remove(code) { this.update(this.codes().filter((c) => c.toLowerCase() !== code.toLowerCase())); }
      sections() {
        if (this.dataset.context === 'drawer') return ['cart-drawer', 'cart-icon-bubble'];
        const ids = [...document.querySelectorAll('#main-cart-items[data-id], #main-cart-footer[data-id]')].map((el) => el.dataset.id);
        return ids.concat('cart-icon-bubble');
      }
      async update(codes) {
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('button').forEach((b) => (b.disabled = true));
        if (this.error) this.error.hidden = true;
        try {
          const res = await fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(','), sections: this.sections() }),
          });
          if (!res.ok) throw new Error(res.status);
          const state = await res.json();
          this.render(state);
        } catch (e) {
          this.removeAttribute('aria-busy');
          this.querySelectorAll('button').forEach((b) => (b.disabled = false));
          if (this.error) { this.error.textContent = this.error.dataset.msg || this.error.textContent; this.error.hidden = false; }
        }
      }
      render(state) {
        const sections = state.sections || {};
        const drawer = document.querySelector('cart-drawer');
        if (this.dataset.context === 'drawer' && drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
          return;
        }
        Object.keys(sections).forEach((id) => {
          const target = document.getElementById('shopify-section-' + id);
          const html = sections[id] && new DOMParser().parseFromString(sections[id], 'text/html').querySelector('.shopify-section');
          if (target && html) target.innerHTML = html.innerHTML;
        });
      }
    });
  }

  /* ---------- Trusted-Shops-Produktbewertungen: Filter nach Sternen, Sortierung, "Mehr anzeigen" ---------- */
  function initProductReviews(root) {
    (root || document).querySelectorAll('[data-jg-prv]').forEach((box) => {
      if (box._jg) return;
      box._jg = true;
      const list = box.querySelector('.jg-prv__list');
      if (!list) return;
      const src = box.querySelector('template[data-jg-prv-src]');
      const setup = () => {
        // Nur die angezeigten Bewertungen ins DOM hängen (bis zu ~190 Einträge im Template, sichtbar anfangs nur wenige)
        const items = src ? [...src.content.children] : [...list.children];
        if (src) src.remove();
        const per = parseInt(box.dataset.perPage, 10) || 3;
        const more = box.querySelector('[data-jg-prv-more]');
        const sortSel = box.querySelector('[data-jg-prv-sort]');
        const reset = box.querySelector('[data-jg-prv-reset]');
        const status = box.querySelector('[data-jg-prv-status]');
        const bars = [...box.querySelectorAll('[data-jg-prv-filter]')];
        const byDate = (a, b) => b.dataset.t.localeCompare(a.dataset.t);
        const sorts = {
          newest: byDate,
          best: (a, b) => (b.dataset.r - a.dataset.r) || byDate(a, b),
          worst: (a, b) => (a.dataset.r - b.dataset.r) || byDate(a, b),
        };
        let shown = per, filter = box.dataset.defaultFilter === 'top' ? 'top' : 0, sort = 'newest';
        const render = () => {
          const match = (i) => (filter === 'top' ? +i.dataset.r >= 4 : (!filter || +i.dataset.r === filter));
          const visible = items.filter(match).sort(sorts[sort]);
          while (list.firstChild) list.removeChild(list.firstChild);
          const frag = document.createDocumentFragment();
          visible.slice(0, shown).forEach((i) => { i.hidden = false; frag.appendChild(i); });
          list.appendChild(frag);
          if (more) more.hidden = visible.length <= shown;
          bars.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.jgPrvFilter === filter)));
          if (reset) reset.hidden = !filter;
          if (status) {
            if (filter === 'top') status.textContent = (box.dataset.labelTop || '').replace('__N__', visible.length).replace('__T__', items.length);
            else status.textContent = filter ? (box.dataset.labelFiltered || '').replace('__N__', visible.length).replace('__S__', filter) : '';
          }
        };
        if (more) more.addEventListener('click', () => { shown += Math.max(per * 2, 6); render(); });
        if (sortSel) sortSel.addEventListener('change', () => { sort = sortSel.value; shown = per; render(); });
        if (reset) reset.addEventListener('click', () => { filter = 0; shown = per; render(); });
        bars.forEach((b) => b.addEventListener('click', () => {
          const s = +b.dataset.jgPrvFilter;
          filter = filter === s ? 0 : s;
          shown = per;
          render();
        }));
        render();
        box.classList.add('is-ready');
      };
      // Liste erst kurz bevor sie sichtbar wird aufbauen
      if (src && 'IntersectionObserver' in window) {
        let done = false;
        const evs = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
        const run = () => { if (done) return; done = true; io.disconnect(); evs.forEach((ev) => window.removeEventListener(ev, onInteraction)); setup(); };
        // Bei einer Interaktion erst nach dem nächsten Frame aufbauen, sonst verzögert der Aufbau
        // die Reaktion auf genau diesen Tipp/Klick (INP)
        const onInteraction = () => requestAnimationFrame(() => setTimeout(run, 0));
        const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) run(); }, { rootMargin: '800px 0px' });
        io.observe(box);
        // Sicherheitsnetz: spätestens bei der ersten Nutzer-Interaktion aufbauen
        evs.forEach((ev) => window.addEventListener(ev, onInteraction, { passive: true }));
      } else setup();
    });
  }

  /* ---------- Bewertungskarussell: gekürzte Texte per "Mehr lesen" (oder Tipp auf den Text) aufklappen ----------
     Ohne das tippen Nutzer auf den abgeschnittenen Text (toter Klick), ein Doppeltipp zoomt dann die Seite. */
  function initReviewReadMore(track) {
    const run = () => {
      const texts = [...track.querySelectorAll('.jg-prv__item .jg-prv__text')];
      // erst alles messen, dann schreiben (kein Layout-Thrashing)
      const clamped = texts.filter((t) => t.scrollHeight > t.clientHeight + 2);
      clamped.forEach((t) => {
        const item = t.closest('.jg-prv__item');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jg-prv__readmore link';
        btn.textContent = track.dataset.jgReadmore;
        btn.setAttribute('aria-expanded', 'false');
        const toggle = () => {
          const open = item.classList.toggle('is-open');
          btn.textContent = open ? track.dataset.jgReadless : track.dataset.jgReadmore;
          btn.setAttribute('aria-expanded', String(open));
        };
        btn.addEventListener('click', toggle);
        t.addEventListener('click', toggle);
        t.classList.add('is-clamped');
        t.after(btn);
      });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { io.disconnect(); requestAnimationFrame(run); }
      }, { rootMargin: '400px 0px' });
      io.observe(track);
    } else run();
  }

  /* ---------- Trusted-Shops-Bewertungskarussell: Pfeile ---------- */
  function initTsReviewArrows(root) {
    (root || document).querySelectorAll('[data-jg-tsr]').forEach((track) => {
      if (track._jg) return;
      track._jg = true;
      if (track.dataset.jgReadmore) initReviewReadMore(track);
      const list = track.querySelector('.jg-tsr__list');
      const prev = track.querySelector('[data-jg-tsr-prev]');
      const next = track.querySelector('[data-jg-tsr-next]');
      if (!list || !prev || !next) return;
      const step = () => { const item = list.querySelector('.jg-tsr__item'); return item ? item.getBoundingClientRect().width + 12 : list.clientWidth * 0.8; };
      const update = () => {
        // Toleranz = linker Innenabstand der Liste (Scroll-Snap kann initial um diesen Betrag verschieben)
        const pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
        prev.hidden = list.scrollLeft <= pad + 4;
        next.hidden = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
      };
      prev.addEventListener('click', () => list.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => list.scrollBy({ left: step(), behavior: 'smooth' }));
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ---------- Hintergrund-Video im Hero: erst nach dem Seiten-Load laden (Bild bleibt LCP) ---------- */
  function startBgVideos() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    if (reduce || saveData) return;
    document.querySelectorAll('video[data-jg-bg-video]:not([src])').forEach((v) => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      v.src = (mobile && v.dataset.srcMobile) || v.dataset.src;
      v.muted = true;
      v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    });
  }
  if (document.readyState === 'complete') setTimeout(startBgVideos, 300);
  else window.addEventListener('load', () => setTimeout(startBgVideos, 300));

  /* ---------- Header-Höhe als CSS-Variable (transparenter Header über dem Hero) ---------- */
  function setHeaderHeight() {
    const h = document.querySelector('.section-header');
    if (h) document.documentElement.style.setProperty('--jg-header-h', Math.round(h.getBoundingClientRect().height) + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });

  /* ---------- Produkt-Slider: Pfeile auf Höhe der Bildmitte ---------- */
  function placeSliderArrows() {
    document.querySelectorAll('slider-component').forEach((sc) => {
      if (!sc.querySelector(':scope > .product-grid, :scope > .blog__posts')) return;
      const img = sc.querySelector('.card__inner');
      if (!img) return;
      const top = img.getBoundingClientRect().top - sc.getBoundingClientRect().top + img.offsetHeight / 2;
      if (top > 0) sc.style.setProperty('--jg-arrow-top', Math.round(top) + 'px');
    });
  }
  let jgArrowResize;
  window.addEventListener('resize', () => { clearTimeout(jgArrowResize); jgArrowResize = setTimeout(placeSliderArrows, 150); });

  /* ---------- Lazy App-Blöcke ([data-jg-lazy-app] mit <template>) ---------- */
  function mountLazyApp(el) {
    const tpl = el.querySelector('template');
    if (!tpl) return;
    el.replaceChildren(tpl.content.cloneNode(true));
  }
  function initLazyApps(root) {
    const els = [...(root || document).querySelectorAll('[data-jg-lazy-app]')].filter((el) => !el._jg);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(mountLazyApp); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); mountLazyApp(e.target); } });
    }, { rootMargin: '800px 0px' });
    els.forEach((el) => { el._jg = true; io.observe(el); });
  }

  /* ---------- Landing-Modus (?lp=1): Klick aufs Logo (außerhalb des Landing-Modus) beendet ihn ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('.header__heading-link')) {
      try { sessionStorage.removeItem('jgLanding'); } catch (err) { /* ignorieren */ }
    }
  });

  /* ---------- Upgrade-Overlay beim "In den Warenkorb" (Block jg_upsell) ---------- */
  // Fängt das Absenden des Produktformulars ab (auch Sticky-Leiste/Banner, die den Haupt-Button auslösen),
  // zeigt das Upgrade-Angebot und legt danach die gewählte Variante in den Warenkorb -> optional direkt zum Checkout.
  // Die gewählte Set-Größe wird per /cart/update.js auf genau diese Menge gesetzt (nicht addiert) und die jeweils
  // andere Set-Größe entfernt -> kein 2x 3 L oder 3 L + 5 L nach dem Zurück-Button. Andere Artikel bleiben im Warenkorb.
  // Jeder Fehler und jede Zeitüberschreitung (8 s) führt über den Shopify-Warenkorb-Link direkt zum Checkout.
  function jgCartLink(variantId, qty) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/' + variantId + ':' + qty;
  }
  function jgFallbackGo(variantId, qty) { window.location.href = jgCartLink(variantId, qty); }
  async function jgAddAndGo(variantId, qty, data, setIds) {
    const updates = {};
    (setIds || []).forEach((id) => { if (id) updates[id] = 0; });
    updates[variantId] = qty;
    const ctrl = 'AbortController' in window ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), 8000) : null;
    try {
      const res = await fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
        signal: ctrl ? ctrl.signal : undefined,
      });
      if (!res.ok) throw new Error('cart update failed');
    } catch (err) {
      jgFallbackGo(variantId, qty);
      return;
    } finally {
      if (timer) clearTimeout(timer);
    }
    window.location.href = data.dataset.directCheckout === 'true' ? '/checkout' : ((window.routes && window.routes.cart_url) || '/cart');
  }
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    let data, currentId, qty, dialog;
    try {
      const scope = form.closest('.product__info-container, product-info, section') || document;
      data = (scope.querySelector && scope.querySelector('[data-jg-upsell]')) || document.querySelector('[data-jg-upsell]');
      if (!data) return;
      const idInput = form.querySelector('input[name="id"]');
      const qtyInput = document.querySelector('input[name="quantity"][form="' + form.getAttribute('id') + '"], .product-form__quantity input[name="quantity"]');
      qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      currentId = (idInput && idInput.value) || data.dataset.currentVariant;
      dialog = document.querySelector('dialog.jg-upsell');
      if (!currentId) return;
    } catch (err) {
      return; // im Zweifel normales Absenden (Dawn-Warenkorb)
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    const upId = dialog && dialog.dataset.upsellVariant;
    const setIds = [currentId, upId];
    if (!dialog || typeof dialog.showModal !== 'function') {
      // kein Upgrade-Overlay (abgeschaltet, schon größte Größe oder sehr alter Browser): direkt weiter.
      // Lade-Spinner im Button zeigen, damit bis zur Weiterleitung niemand ein zweites Mal tippt.
      if (form._jgBusy) return;
      form._jgBusy = true;
      const btn = form.querySelector('[type="submit"]');
      const spinner = (form.closest('product-form') || form).querySelector('.loading__spinner');
      if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
      if (spinner) spinner.classList.remove('hidden');
      // Zurück-Taste (bfcache): Button wieder freigeben
      window.addEventListener('pageshow', () => {
        form._jgBusy = false;
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
      }, { once: true });
      jgAddAndGo(currentId, qty, data, setIds);
      return;
    }
    if (dialog.open || dialog._jgOpening) return;
    // showModal() macht den Rest der Seite inert und erzwingt eine Neuberechnung aller Styles (~40 ms auf
    // Mittelklasse-Handys). Erst sichtbares Feedback malen lassen, dann öffnen – sonst wartet der Tipp darauf (INP).
    dialog._jgOpening = true;
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.classList.add('jg-is-pressed');
    requestAnimationFrame(() => setTimeout(() => {
      dialog._jgOpening = false;
      if (submitBtn) submitBtn.classList.remove('jg-is-pressed');
      try {
        if (!dialog.open) dialog.showModal();
      } catch (err) {
        jgAddAndGo(currentId, qty, data, setIds);
      }
    }, 0));
    dialog.querySelectorAll('[data-jg-upsell-choice]').forEach((btn) => {
      btn.onclick = () => {
        const id = btn.dataset.jgUpsellChoice === 'up' && upId ? upId : currentId;
        dialog.querySelectorAll('button').forEach((b) => { b.disabled = true; });
        btn.classList.add('loading');
        jgAddAndGo(id, qty, data, setIds).catch(() => jgFallbackGo(id, qty));
      };
    });
  }, true);
  // Hintergrund-Klick und Esc gelten wie "Nein danke": mit der aktuellen Größe weiter zum Checkout
  document.addEventListener('click', (e) => {
    if (e.target.matches && e.target.matches('dialog.jg-upsell[open]')) {
      const no = e.target.querySelector('.jg-upsell__no');
      if (no && !no.disabled) no.click();
    }
  });
  document.addEventListener('cancel', (e) => {
    if (e.target.matches && e.target.matches('dialog.jg-upsell')) {
      e.preventDefault();
      const no = e.target.querySelector('.jg-upsell__no');
      if (no && !no.disabled) no.click();
    }
  }, true);

  /* ---------- Größen-Auswahl (eigene Produkte) ohne Seiten-Reload wechseln ---------- */
  // Lädt nur die produktabhängigen Sektionen per Section Rendering API und tauscht sie aus.
  const SIZE_SECTIONS = ['main', 'jg_offer_cta', 'jg_lab_proof', 'jg_ts_product_reviews', 'jg_ts_product_reviews_all'];
  const sizeCache = {};
  function sizeSectionIds() {
    return [...document.querySelectorAll('[id^="shopify-section-template--"]')]
      .map((el) => el.id.replace('shopify-section-', ''))
      .filter((id) => SIZE_SECTIONS.some((s) => id.endsWith('__' + s)));
  }
  function fetchSize(url) {
    const ids = sizeSectionIds();
    if (!ids.length) return null;
    const u = new URL(url, location.origin);
    u.searchParams.set('sections', ids.join(','));
    if (!sizeCache[url]) sizeCache[url] = fetch(u.toString()).then((r) => (r.ok ? r.json() : Promise.reject(r.status)));
    return sizeCache[url];
  }
  async function switchSize(link, push) {
    const url = link.getAttribute('href');
    const box = link.closest('.jg-sizes');
    if (box) box.classList.add('is-loading');
    try {
      const data = await fetchSize(url);
      if (!data) throw new Error('keine Sektionen');
      Object.entries(data).forEach(([id, html]) => {
        const current = document.getElementById('shopify-section-' + id);
        if (!current || !html) return;
        const next = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-' + id);
        if (next) { current.replaceWith(next); initAll(next); }
      });
      const h1 = document.querySelector('.product__title h1');
      if (h1) document.title = h1.textContent.trim() + ' – ' + (document.title.split(' – ').pop() || '');
      if (push) history.pushState({ jgSize: true }, '', url);
    } catch (err) {
      location.href = url; // Fallback: normaler Seitenwechsel
    }
  }
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.jg-sizes__opt');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (link.classList.contains('is-active')) return;
    switchSize(link, true);
  });
  // beim Überfahren/Antippen schon vorladen
  ['pointerenter', 'touchstart'].forEach((ev) => document.addEventListener(ev, (e) => {
    const link = e.target.closest && e.target.closest('.jg-sizes__opt:not(.is-active)');
    if (link) fetchSize(link.getAttribute('href'));
  }, { capture: true, passive: true }));
  window.addEventListener('popstate', (e) => { if (e.state && e.state.jgSize) location.reload(); });
  if (document.querySelector('.jg-sizes')) history.replaceState({ jgSize: true }, '', location.href);

  /* ---------- Guthaben-Hinweis: Betrag bei Variantenwechsel neu berechnen ---------- */
  function jgFormatMoney(cents, format) {
    const fmt = (n, d, ts, ds) => {
      const [i, f] = (n / 100).toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals') return fmt(cents, 0, ',', '.');
      if (key === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.', ',');
      if (key === 'amount_with_apostrophe_separator') return fmt(cents, 2, "'", '.');
      return fmt(cents, 2, ',', '.');
    });
  }
  let creditSubscribed = false;
  function initCredit() {
    if (creditSubscribed || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    creditSubscribed = true;
    subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
      const v = e && e.data && e.data.variant;
      if (!v) return;
      document.querySelectorAll('[data-jg-credit][data-section="' + e.data.sectionId + '"]').forEach((el) => {
        const cents = Math.round(v.price * Number(el.dataset.percent) / 100);
        const amount = el.querySelector('strong');
        if (amount) amount.textContent = jgFormatMoney(cents, el.dataset.format);
        el.hidden = cents <= 0;
      });
    });
    // Warenkorb: Guthaben aus dem neuen Warenkorbwert (Drawer wird ohnehin neu gerendert, Warenkorbseite nicht)
    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      const total = e && e.cartData && e.cartData.total_price;
      if (typeof total !== 'number') return;
      document.querySelectorAll('[data-jg-cart-credit]').forEach((el) => {
        const cents = Math.round(total * Number(el.dataset.percent) / 100);
        const amount = el.querySelector('strong');
        if (amount) amount.textContent = '+ ' + jgFormatMoney(cents, el.dataset.format);
        el.hidden = cents <= 0;
      });
    });
  }

  /* ---------- Aufklapp-Buttons (Checkbox-Hack) ohne Sprung nach oben ----------
     Ein Klick aufs Label fokussiert die versteckte Checkbox oben im Block -> Browser scrollt dorthin.
     Stattdessen selbst umschalten und den Button an seiner Bildschirmposition halten. */
  document.addEventListener('click', (e) => {
    const label = e.target.closest('label.jg-cdc__more, label.jg-readmore__btn');
    if (!label) return;
    const input = document.getElementById(label.htmlFor);
    if (!input) return;
    e.preventDefault();
    const top = label.getBoundingClientRect().top;
    input.checked = !input.checked;
    const delta = label.getBoundingClientRect().top - top;
    if (delta) window.scrollBy({ top: delta, behavior: 'instant' });
  });

  /* ---------- Footer-Newsletter direkt in die Klaviyo-Liste ----------
     Landet so in der Liste, die den Willkommens-Flow startet (Shopify-Kundenformular als Fallback). */
  document.addEventListener('submit', (e) => {
    const box = e.target.closest('[data-jg-klaviyo-list]');
    if (!box || box.classList.contains('is-loading')) return;
    const form = e.target;
    const email = (form.querySelector('input[type="email"]') || {}).value;
    if (!email) return;
    e.preventDefault();
    box.classList.add('is-loading');
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(box.dataset.jgKlaviyoCompany), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: box.dataset.jgKlaviyoSource || 'Footer',
        profile: { data: { type: 'profile', attributes: { email: email.trim() } } }
      }, relationships: { list: { data: { type: 'list', id: box.dataset.jgKlaviyoList } } } } })
    }).then((res) => {
      if (!res.ok) throw new Error(res.status);
      form.hidden = true;
      const ok = box.querySelector('[data-jg-newsletter-success]');
      if (ok) { ok.hidden = false; ok.setAttribute('tabindex', '-1'); ok.focus(); }
    }).catch(() => form.submit())
      .finally(() => box.classList.remove('is-loading'));
  });

  function initAll(root) { initCredit(); initDelivery(root); initCompare(root); initSteps(root); initMaps(root); initLazyApps(root); initMarquees(root); placeSliderArrows(); initTsReviewArrows(root); initProductReviews(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
